/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Image_Viewer_Regenerate_HintInputs */



/**
* | output |
* | --- |
* | "Adjust the prompt and generate a new image." |
*
* @param {Chat_Image_Viewer_Regenerate_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_image_viewer_regenerate_hint = /** @type {((inputs?: Chat_Image_Viewer_Regenerate_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Image_Viewer_Regenerate_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passen Sie den Prompt an und erzeugen Sie ein neues Bild.")
	return /** @type {LocalizedString} */ ("Adjust the prompt and generate a new image.")
});